<div
  class="filter-container"
  style="background-color: #fff; padding: 1rem; margin-bottom: 1rem"
  *ngIf="showTableFilters">
  <h6 style="font-weight: bold">Filters:</h6>
  <div
    *ngFor="let filter of filterSelectObj"
    matColumnDef="filter-{{ filter.columnProp }}">
    <div class="filter">
      <ng-container [ngSwitch]="filter.type">
        <!-- Autocomplete -->
        <div *ngSwitchCase="'autocomplete'" class="filter-container">
          <app-multi-select-autocomplete
            [options]="filter.options"
            [label]="filter.name"
            [optionsWidth]="filter.optionsWidth || undefined"
            (selectionChange)="
              filterChange(filter, $event)
            "></app-multi-select-autocomplete>
        </div>

        <!-- Select -->
        <div *ngSwitchCase="'select'" class="filter-container">
          <mat-form-field
            appearance="standard"
            color="accent"
            class="filter-field"
            style="min-width: 50px; width: 100%; padding-right: 0.2rem">
            <mat-label>{{ filter.name }}</mat-label>
            <mat-select
              [(ngModel)]="filter.modelValue"
              (selectionChange)="filterChange(filter, $event)"
              multiple>
              <mat-option *ngFor="let item of filter.options" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div class="mat-table-global">
  <table
    [dataSource]="dataSource"
    mat-table
    matSort
    matTableResponsive
    multiTemplateDataRows
    id="support-list-table">
    <ng-container matColumnDef="statusCodeString">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        <div style="display: flex; align-items: center">
          <div
            class="action-icon-container mr-2"
            [class.disabled]="element.caseNumber === cancelingCaseId"
            [style.pointerEvents]="
              element.caseNumber === cancelingCaseId ? 'none' : 'auto'
            "
            (click)="
              element.caseNumber !== cancelingCaseId && viewCaseDetails(element)
            ">
            <mat-spinner
              class="loading-spinner"
              strokeWidth="2"
              diameter="20"
              *ngIf="
                element.caseNumber === cancelingCaseId;
                else visibility
              "></mat-spinner>
            <ng-template #visibility>
              <img
                src="../assets/images/visibility.svg"
                alt="View Case Details" />
            </ng-template>
          </div>
          <div
            class="status-bubble"
            [ngClass]="{
              'resolved-bubble': element.statusCodeString === 'Resolved',
              'in-progress-bubble': element.statusCodeString === 'In Progress',
              'needs-input-bubble':
                element.statusCodeString === 'Needs Customer Input',
              'new-bubble': element.statusCodeString === 'New',
              'cancelled-bubble': element.statusCodeString === 'Cancelled'
            }">
            {{ element.statusCodeString }}
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="caseNumber">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Case No.</th>
      <td mat-cell *matCellDef="let element">{{ element.caseNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="caseTypeCodeString">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Case Type</th>
      <td mat-cell *matCellDef="let element">
        {{ element.caseTypeCodeString }}
      </td>
    </ng-container>

    <ng-container matColumnDef="customerName">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Site</th>
      <td mat-cell *matCellDef="let element">
        {{ element.customerName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Case Summary</th>
      <td mat-cell *matCellDef="let element">{{ element.title }}</td>
    </ng-container>

    <ng-container matColumnDef="createdDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Created On</th>
      <td mat-cell *matCellDef="let element">
        {{ datePipe.transform(element.createdDate, 'MM/dd/yyyy') }}
      </td>
    </ng-container>

    <ng-container matColumnDef="modifiedDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Modified On</th>
      <td mat-cell *matCellDef="let element">
        {{ datePipe.transform(element.modifiedDate, 'MM/dd/yyyy') }}
      </td>
    </ng-container>

    <ng-container matColumnDef="isEscalated">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Escalated</th>
      <td mat-cell *matCellDef="let element">
        {{
          element.isEscalated && element.statusCodeString !== 'Resolved'
            ? 'Yes'
            : 'No'
        }}
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="action">
      <th class="action-column text-center" mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td class="action-column" mat-cell *matCellDef="let element">
        <div class="action-icon-container" (click)="viewCaseDetails(element)">
          <img src="../assets/images/visibility.svg" alt="View" />
        </div>
      </td>
    </ng-container> -->

    <!-- Filter Row -->
    <ng-container
      *ngFor="let filter of filterSelectObj"
      matColumnDef="filter-{{ filter.columnProp }}">
      <th mat-header-cell *matHeaderCellDef>
        <ng-container [ngSwitch]="filter.type">
          <!-- Autocomplete -->
          <div *ngSwitchCase="'autocomplete'" class="filter-container">
            <app-multi-select-autocomplete
              [options]="filter.options"
              [label]="filter.name"
              [optionsWidth]="filter.optionsWidth || undefined"
              (selectionChange)="
                filterChange(filter, $event)
              "></app-multi-select-autocomplete>
          </div>

          <!-- Select -->
          <div *ngSwitchCase="'select'" class="filter-container">
            <mat-form-field
              appearance="standard"
              color="accent"
              class="filter-field"
              style="min-width: 50px; width: 100%; padding-right: 0.2rem">
              <mat-label>{{ filter.name }}</mat-label>
              <mat-select
                [(ngModel)]="filter.modelValue"
                (selectionChange)="filterChange(filter, $event)"
                multiple>
                <mat-option *ngFor="let item of filter.options" [value]="item">
                  {{ item }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
      </th>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="8"
        id="support-list-details"
        [ngClass]="
          expandedElement && expandedElement.id === element.id
            ? 'details-expanded'
            : 'details-collapsed'
        ">
        <div
          class="element-detail"
          [@detailExpand]="
            expandedElement && expandedElement.id === element.id
              ? 'expanded'
              : 'collapsed'
          ">
          <app-support-list-detail
            [caseDetails]="element.details"
            [element]="element"
            (expandedElementEvent)="
              setExpandedElement($event)
            "></app-support-list-detail>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
      class="table-header-row"></tr>

    <!-- Filter Header Row -->
    <tr mat-header-row *matHeaderRowDef="filterDisplayedColumns"></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="table-data-row table-data-row-hidden"
      [ngClass]="{
        escalated: row.isEscalated && row.statusCodeString !== 'Resolved'
      }"
      [class.element-row]="expandedElement === row"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="expanded-detail-row"></tr>
  </table>

  <div
    *ngIf="!dataSource?.data?.length"
    style="background-color: white"
    class="text-center no-records-message">
    No records found
  </div>
  <mat-paginator
    class="table-paginator-row"
    [pageSizeOptions]="[10, 20, 30]"
    showFirstLastButtons></mat-paginator>
</div>
